import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { FaEye, FaDownload } from 'react-icons/fa'; // For icons
import './AllOrderList.css'; // Import the CSS file for styling

const AllOrderList = () => {
  const [userData, setUserData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const history = useHistory();

  useEffect(() => {
    // Fetch data and set it to userData state
    // Example static data
    setUserData([
      {
        id: 1,
        orderId: 'ORD123',
        orderDate: '2024-08-20',
        customerInfo: { name: 'John Doe', contactNumber: '+1234567890' },
        vendor: 'Vendor A',
        totalAmount: 'Rs.100',
        status: 'Pending'
      },
      {
        id: 2,
        orderId: 'ORD124',
        orderDate: '2024-08-21',
        customerInfo: { name: 'Jane Smith', contactNumber: '+0987654321' },
        vendor: 'Vendor B',
        totalAmount: 'Rs.200',
        status: 'Delivered'
      },
      // Add more static data as needed
    ]);
  }, []);

  const handleStatusChange = (orderId, newStatus) => {
    // Update the status locally (or make an API call to update it)
    setUserData(userData.map(order =>
      order.orderId === orderId ? { ...order, status: newStatus } : order
    ));
    console.log('Change status for order ID:', orderId, 'to', newStatus);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>All Order List</h2>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
                <th>Order ID</th>
                <th>Order date</th>
                <th>Customer info</th>
                <th>Vendor</th>
                <th>Total amount</th>
                <th>Order status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {userData.map((order, index) => (
                <tr key={order.id}>
                  <td>{index + 1}</td>
                  <td>{order.orderId}</td>
                  <td>{order.orderDate}</td>
                  <td>{`${order.customerInfo.name} (${order.customerInfo.contactNumber})`}</td>
                  <td>{order.vendor}</td>
                  <td>{order.totalAmount}</td>
                  <td>
                    <select
                      value={order.status}
                      onChange={(e) => handleStatusChange(order.orderId, e.target.value)}
                    >
                      <option value="Delivered">Delivered</option>
                      <option value="Pending">Pending</option>
                      <option value="Failed to deliver">Failed to deliver</option>
                      <option value="Confirmed">Confirmed</option>
                      <option value="Out for delivery">Out for delivery</option>
                      <option value="Packaging">Packaging</option>
                    </select>
                  </td>
                  <td>
                    <button
                      className="btn-view"
                      onClick={() => history.push(`/view/${order.orderId}`)}
                    >
                      <FaEye title="View" />
                    </button>
                    <button
                      className="btn-download"
                      onClick={() => console.log('Download order ID:', order.orderId)}
                    >
                      <FaDownload title="Download" />
                    </button>
                  
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      
      </div>
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(AllOrderList);
